import React from "react";
import { XCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";

const PaymentCancel: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F6EBDD] text-[#2D1B44]">
      <div className="relative mx-auto flex min-h-screen max-w-4xl items-center justify-center px-6 py-16">
        <div className="pointer-events-none absolute -left-16 top-10 h-64 w-64 rounded-full bg-[#F6B9D8] blur-3xl opacity-70" />
        <div className="pointer-events-none absolute -bottom-20 -right-20 h-72 w-72 rounded-full bg-[#A9B9FF] blur-3xl opacity-60" />
        <div className="pointer-events-none absolute right-10 top-24 h-56 w-56 rounded-full bg-[#B7F2FF] blur-3xl opacity-50" />

        <div className="relative w-full max-w-2xl overflow-hidden rounded-[32px] border border-white/60 bg-white/75 p-10 text-center shadow-[0_24px_60px_rgba(45,27,68,0.16)] backdrop-blur">
          <div className="flex flex-col items-center gap-2">
            <img
              src={"/logo_2.png"}
              alt="Astria"
              className="h-14 w-auto object-contain"
            />
            <span className="text-sm font-semibold uppercase tracking-[0.4em] text-[#6D4C92]">
              Astria
            </span>
          </div>
          <div className="mx-auto mt-6 flex h-20 w-20 items-center justify-center rounded-full bg-[#F2E7FF]">
            <div className="flex h-14 w-14 items-center justify-center rounded-full bg-[#2D1B44] text-[#F6EBDD] shadow-lg">
              <XCircle className="h-8 w-8" />
            </div>
          </div>
          <h1 className="mt-6 font-['Fraunces'] text-4xl font-semibold">
            Payment Canceled
          </h1>
          <p className="mt-3 font-['Manrope'] text-base text-[#2D1B44]/70">
            No worries. Your payment was canceled and no charges were made.
          </p>
          <div className="mt-8 rounded-2xl border border-[#2D1B44]/10 bg-[#F6EBDD] p-5 text-left text-sm text-[#2D1B44]/70">
            If you were just exploring, you can always come back later. Your
            cart is saved with the same plan selection.
          </div>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <button
              onClick={() =>
                navigate("/journey")
              }
              className="rounded-full bg-[#2D1B44] px-5 py-2 text-sm font-semibold text-[#F6EBDD] transition hover:shadow-lg"
            >
              {"Back to Journey"}
            </button>
            <button
              onClick={() => navigate("/")}
              className="rounded-full border border-[#2D1B44]/20 px-5 py-2 text-sm font-semibold text-[#2D1B44] transition hover:border-[#2D1B44]/40"
            >
              Go to Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
